import { GenericVoucherKind, GenericVoucherStrategy } from '@modules/generic-vouchers/models'
import { useProductsAppData } from '@modules/products/hooks/use-products-app-data'

export const useGenericVoucherStrategyProvider = (kind: GenericVoucherKind): GenericVoucherStrategy => {
  const appData = useProductsAppData()

  return appData.generic_voucher_strategies[kind]
}
